<template>
  <div class="container">
    <div class="success" v-show="isShow">
      <div class="image">
        <img src="../../../assets/images/success.png" alt />
      </div>
      <p class="successText">发布成功</p>
      <p class="waiting">平台审核中，请耐心等待...</p>
    </div>
    <div class="fail" v-show="!isShow">
      <div class="image">
        <img src="../../../assets/images/success.png" alt />
      </div>
      <p class="failText">发布失败</p>
      <p class="waiting">请稍后重试...</p>
    </div>
  </div>
</template>
<script>
import { CellGroup, Form, Field } from "vant";
export default {
  components: {
    [CellGroup.name]: CellGroup,
    [Form.name]: Form,
    [Field.name]: Field
  },
  data() {
    return {
      isShow: true
    };
  },
  methods: {}
};
</script>
<style lang="less">
.container {
    height: 100%;
  .success {
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin-top: -30vw;
  }
  .fail {
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin-top: -30vw;
  }
  .image {
    width: 66px;
    height: 76px;
  }
  .successText {
    color: #ee0a24;
    font-size: 20px;
    letter-spacing: 3px;
    font-weight: bold;
  }
  .failText{
      color: #ccc;
    font-size: 20px;
    letter-spacing: 3px;
    font-weight: bold;
  }
  .waiting {
    color: #333333;
  }
}
</style>